<template>
  <div class="solution_box">
    <div class="pc">
      <div class="header_img">
        解决方案
      </div>
      <div style="margin: 70px 0;">
        <Title>商旅酒店行业痛点</Title>
      </div>
      <div class="difficulty_box">
        <div></div>
        <div class="difficulty_content">
          <div class="diff_item">
            <div>
              <p class="title">上游资源分散</p>
              <ul>
                <li>全球酒店（包括非标住宿）超过100万家，资源整合成本高。</li>
                <li>除连锁酒店集团外，还有超过50%的单体酒店。</li>
              </ul>
            </div>
            <div class="dig">1</div>
          </div>
          <div class="diff_item">
            <div>
              <p class="title">信息化程度低</p>
              <ul>
                <li>供应和分销端信息化程度低、信息不对称、效率低。</li>
                <li>信息化趋势下大多供应商和分销商难以承担自建技术成本。</li>
              </ul>
            </div>
            <div class="dig">2</div>
          </div>
          <div class="diff_item">
            <div>
              <p class="title">供应链建设门槛高</p>
              <ul>
                <li>住宿行业没有像机票集中度高，采购供应分销库存成本高、门槛高。</li>
                <li>OTA巨头能依靠大量地推人员建立供应链能力。</li>
              </ul>
            </div>
            <div class="dig">3</div>
          </div>
          <div class="diff_item" style="grid-template-columns: 75% 25%;">
            <div>
              <p class="title">预定环节复杂</p>
              <ul>
                <li>价格体系复杂，其中在线比例仅40%；大量的交易仍然在线下完成。</li>
                <li>客房销售有很强的时效性，对信息实时性要求很高。</li>
              </ul>
            </div>
            <div class="dig">4</div>
          </div>
        </div>
        <div></div>
      </div>

      <div class="center_box">
        <div></div>
        <div>
          <div style="margin-bottom: 70px;">
            <Title>商旅酒店供应链服务</Title>
          </div>
          <div class="info_card">
            <div class="item" v-for="(item, index) in solutionList" :key="index">
              <img :src="item.img">
              <div class="desc_box">
                <p class="title">{{ item.title }}</p>
                <p class="desc">{{ item.desc }}</p>
                <p class="learn_more" @click="learnMore(index)">{{ item.btn }}</p>
              </div>
            </div>
          </div>
        </div>
        <div></div>
      </div>

      <!-- <div class="model_box">
                  <div></div>
                  <div>
                    <Title>业务模式</Title>
                    <img src="../../../assets/newWebSiteImg/pc/solution/model.png">
                  </div>
                  <div></div>
                </div> -->

      <!-- <div class="main_body_register">
                <div class="to_register">
                  <div style="margin-bottom: 30px;">
                    <span style="font-size: 30px;font-weight: bold;">获取适合您企业的最佳解决方案</span>
                  </div>
                  <div>
                    <span
                      style="font-size: 15px;border: 1px solid #fff;padding: 6px 22px;font-family: '苹方' ;border-radius:5px;cursor: pointer;"
                      @click="solutionDialog = true">
                      立即获取
                    </span>
                  </div>
                </div>
              </div> -->

      <!-- <el-dialog title="获取您的解决方案" :visible.sync="solutionDialog" width="700px" :close-on-click-modal="false">
                <div class="dialog_box">
                  <p style="font-size: 18px;margin-bottom: 20px;">我是</p>
                  <div style="margin-bottom: 40px;">
                    <el-radio v-model="solutionForm.radio" label="1">商旅公司</el-radio>
                    <el-radio v-model="solutionForm.radio" label="2">在线旅游平台</el-radio>
                    <el-radio v-model="solutionForm.radio" label="3">大型企业集团</el-radio>
                    <el-radio v-model="solutionForm.radio" label="4">旅行社</el-radio>
                    <el-radio v-model="solutionForm.radio" label="5">SaaS厂商</el-radio>
                  </div>
                  <p style="font-size: 18px;color: #fe8f1d;margin-bottom: 30px;">* 请留下您的联系方式</p>
                  <el-form ref="solutionForm" :model="solutionForm" label-width="75px" label-position="left">
                    <el-form-item label="企业名称:">
                      <el-input v-model="solutionForm.a"></el-input>
                    </el-form-item>
                    <el-form-item label="联系人:">
                      <el-input v-model="solutionForm.b"></el-input>
                    </el-form-item>
                    <el-form-item label="联系电话:">
                      <el-input v-model="solutionForm.c"></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱:">
                      <el-input v-model="solutionForm.d"></el-input>
                    </el-form-item>
                  </el-form>
                  <div style="text-align:center;">
                    <b2b-button style="width: 130px;height: 40px;line-height: 40px;background-color:#fe8f1d;font-size: 16px;"
                      @click="submit">提交</b2b-button>
                  </div>
                </div>
              </el-dialog> -->
    </div>


    <div class="app">

    </div>
  </div>
</template>

<script>
import Title from '../components/Title.vue';
export default {
  data () {
    return {
      solutionList: [{
        img: require('@/assets/newWebSiteImg/pc/solution/fa1.png'),
        title: '酒店资源覆盖',
        desc: '整合全球100W+酒店资源，独家商旅价格政策',
        btn: ''
      }, {
        img: require('@/assets/newWebSiteImg/pc/solution/fa2.png'),
        title: '多供应商聚合',
        desc: '支持多供应商比价，个性化加幅输出，降本增效。',
        btn: ''
      }, {
        img: require('@/assets/newWebSiteImg/pc/solution/fa3.png'),
        title: '酒店预定平台',
        desc: '可通过B2B网站或小程序实时查询全球酒店资源，全流程跟踪；更简单，快速，稳定',
        btn: '前往预订'
      }, {
        img: require('@/assets/newWebSiteImg/pc/solution/fa4.png'),
        title: '协议酒店托管',
        desc: '完善的分销代理解决方案，支持规模化酒店产品售卖、客服、结算等服务',
        btn: ''
      }, {
        img: require('@/assets/newWebSiteImg/pc/solution/fa5.png'),
        title: 'B2B分销服务',
        desc: '完善的API分销解决方案，支持规模化酒店产品售卖、客服、结算等服务',
        btn: ''
      }, {
        img: require('@/assets/newWebSiteImg/pc/solution/fa6.png'),
        title: '统一结算服务',
        desc: '为您提供统一对账、统一结算服务',
        btn: ''
      }],
      // solutionDialog: false,
      // solutionForm: {
      //   radio: '',
      //   a: '',
      //   b: '',
      //   c: '',
      //   d: ''
      // }
    }
  },
  components: {
    Title
  },
  methods: {
    // submit () {
    //   console.log(this.solutionForm)
    // },
    learnMore (index) {
      if (index == 2) {
        window.open('/Login', '_blank');
      }
    }
  }
}
</script>

<style lang="less" scoped>
.solution_box {
  @media screen and (min-width: 992px) {
    .pc {
      display: block;
    }

    .app {
      display: none;
    }
  }

  @media screen and (max-width: 992px) {
    .pc {
      display: none;
    }

    .app {
      display: block;
    }
  }
}

.solution_box {
  .pc {
    .header_img {
      height: 350px;
      line-height: 350px;
      text-align: center;
      background-image: url('../../../assets/newWebSiteImg/pc/solution/bg1.png');
      background-size: 100% 100%;
      color: #fff;
      font-size: 100px;
      font-weight: 600;
      letter-spacing: 2px;
    }

    .difficulty_box {
      display: grid;
      grid-template-columns: auto 1401px auto;
      margin-bottom: 70px;

      .difficulty_content {
        padding-left: 130.5px;
        display: grid;
        grid-template-columns: repeat(2, 555px);
        grid-gap: 30px;

        .diff_item {
          box-shadow: 5px 5px 20px #1312121c;
          padding: 20px;

          display: flex;
          justify-content: space-between;
          align-items: center;

          .dig {
            width: 75px;
            height: 140px;
            font-weight: bolder;
            font-size: 120px;
            line-height: 140px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            background-image: linear-gradient(to bottom, #d9d9d9 0%, #fafafa 100%);
            -webkit-background-clip: text; /* 兼容WebKit内核 */
            background-clip: text;
            -webkit-text-fill-color: transparent; /* 兼容WebKit内核 */
            color: transparent; /* 标准属性 */
          }

          .title {
            font-size: 24px;
            margin-bottom: 15px;
            margin-top: 20px;
          }

          ul {
            list-style-type: disc;
            margin-left: 15px;

            li {
              font-family: '苹方';
              min-height: 25px;
              line-height: 25px;
              font-size: 14px;
              color: #8c8b8b;
            }
          }

          img {
            height: 80%;
            width: inherit;
          }
        }
      }
    }

    .center_box {
      background-color: #fff3e7;
      min-height: 750px;
      padding: 80px 0;
      display: grid;
      grid-template-columns: auto 1401px auto;

      .info_card {
        display: grid;
        grid-template-columns: repeat(3, 448px);
        grid-gap: 30px;

        .item {
          background-color: #fff;
          box-shadow: 5px 5px 15px #f8ece1;
          font-family: '苹方';

          img {
            width: 100%;
            object-fit: cover;
            height: 100px;
          }

          .desc_box {
            padding: 20px;

            .title {
              font-size: 24px;
              margin-bottom: 15px;
            }

            .desc {
              font-size: 14px;
              margin-bottom: 35px;
              line-height: 20px;
              color: #737272;
            }

            .learn_more {
              font-size: 14px;
              color: #fe9738;
              cursor: pointer;
              user-select: none;
            }
          }
        }
      }

    }

    // .model_box {
    //   display: grid;
    //   grid-template-columns: auto 1401px auto;
    //   padding: 0 40px;
    //   margin: 80px 0;
    //   margin-bottom: 100px;

    //   img {
    //     margin-top: 20px;
    //     width: 1153px;
    //     margin-left: 10%;
    //     height: 809px;
    //     object-fit: contain;
    //   }
    // }

    .main_body_register {
      background-image: url('../../../assets/newWebSiteImg/pc/solution/get.png');
      width: 100%;
      height: 150px;
      background-size: cover;
      text-align: center;
      color: #fff;
      position: relative;
      // margin-top: 100px;

      .to_register {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .dialog_box {
      /deep/.el-input__inner {
        height: 28px;
        line-height: 28px;
      }
    }

    /deep/.el-dialog__header {
      background-color: #fff;
    }

    /deep/.el-dialog__title {
      color: #000;
      font-size: 28px;
    }

    /deep/.el-dialog__body {
      border-top: 1px solid #ebebeb;
      margin: 0 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newWebsite/main/solution.vue